import React from "react";

import FullscreenSolution from "../../components/FullscreenSolution";

import styles from "../Solutions.module.css";

const SolutionsFullscreenText = ({
	activeSlide,
	nextLiveSlide,

	fsTextScrollEnabled,
	overlayInTrans,
	debugComplication,

	isPortraitMode,
	isPortraitModeRef,

	isCurrentlyHoveredRef,

	wasSearchCloseRef,
	wasDragRef,
	isLongPressRef,

	fullscreenTextRef,
	fullscreenSolutionRef,

	windowSize,

	solution,
	caseFilter,

	setHoverTimeout,
	handleSlideExit,
	setNewFilter,
	handleVideoModalOpen,
	handleVisitSite,
}) => {
	const interactionBlocked =
		() => {
			return (
				wasSearchCloseRef.current ||
				wasDragRef.current ||
				isPortraitModeRef.current ||
				isLongPressRef.current
			);
		};

	return (
		<div
			className="sol-fs-txt-wrapper-v2"
			onClick={(e) => {
				if (
					isCurrentlyHoveredRef.current
				) {
					setHoverTimeout(
						true,
					);
				}

				if (
					interactionBlocked()
				) {
					return false;
				}

				if (
					e.target.className ===
					"sol-fs-txt-v2"
				) {
					handleSlideExit();
				}
			}}
			style={{
				pointerEvents:
					activeSlide !== -1 &&
					fsTextScrollEnabled
						? "auto"
						: "none",
			}}
		>
			<div
				className={`sol-fs-txt-v2 ${styles.hiddenContent}`}
				ref={
					fullscreenTextRef
				}
				onClick={(e) => {
					if (
						interactionBlocked()
					) {
						return false;
					}

					if (
						e.target
							.className ===
						"top-filler"
					) {
						handleSlideExit();
					}
				}}
			>
				{debugComplication >
				-1 ? null : (
					<FullscreenSolution
						fullscreenText_v2={
							fullscreenTextRef
						}
						index={
							nextLiveSlide
						}
						fsTextScrollEnabled={
							fsTextScrollEnabled
						}
						key="fullscreen_solution"
						ref={
							fullscreenSolutionRef
						}
						windowSize={
							windowSize
						}
						isPortraitMode={
							isPortraitMode
						}
						solution={
							solution
						}
						activeSlide={
							nextLiveSlide
						}
						handleSlideExit={
							handleSlideExit
						}
						setNewFilter={
							setNewFilter
						}
						overlayInTrans={
							overlayInTrans
						}
						handleVideoModalOpen={
							handleVideoModalOpen
						}
						handleVisitSite={
							handleVisitSite
						}
						caseFilter={
							caseFilter
						}
					/>
				)}
			</div>
		</div>
	);
};

export default React.memo(
	SolutionsFullscreenText,
);